import { render, staticRenderFns } from "./Avatar.component.vue?vue&type=template&id=6dfcc5dc&scoped=true&lang=pug"
import script from "./Avatar.component.vue?vue&type=script&lang=ts"
export * from "./Avatar.component.vue?vue&type=script&lang=ts"
import style0 from "./Avatar.component.vue?vue&type=style&index=0&id=6dfcc5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfcc5dc",
  null
  
)

export default component.exports